import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
import MaterialTable from "material-table";
import { forwardRef } from 'react';
import { CSVLink } from "react-csv";


import { api_host, api_auth } from '../../../../../common/globals/constants';
import at_codes_ok from '../../../../../data/codes_ok'

import Checkbox from '@material-ui/core/Checkbox';
import PortletContent from 'components/PortletContent';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment'
import 'moment/locale/es'  
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';
moment.locale('es')


class AvailabilityData extends Component {

    constructor(props) {
        super(props);
        this.translation = (this.props && this.props.t) ? this.props.t : (s => s);
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            nameObjective: this.props.match.params.nombre_objetivo,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            step: null,
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            data: null,
            dataTab: null,
            //value: ',',
            noMonCum: null,
            downCum: null,
            date: this.props.params.date,
            dateMoment: ((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")),
            isRefresh: this.props.params.isRefresh,
            checkedDowntime: false,
            checkedUptime: true,
            checkedPartial: false,
            checkedNoMon: false,
            checkedEvent: false,
            checkedMarcadoAtentus: false,
            checked: true,
            valueDecimal: '.',
            beginDate: null,
            endDate: null,
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        
        if (nextProps.params.period !== prevState.time) {

            return {
                externalData: null,
                //prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                rows: null,
                statePeriod: nextProps.params.statePeriod,
                //isStatePeriod: nextProps.params.isStatePeriod
            }
        } else if(nextProps.params.isRefresh !== prevState.isRefresh){
            return {
                externalData: null,
                //prevObjectiveId: props.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                rows: null,
                statePeriod: nextProps.params.statePeriod,
                isRefresh: nextProps.params.isRefresh,          
            }

        } else if ((nextProps.params.period === prevState.time) && (nextProps.params.statePeriod !== prevState.statePeriod)) {
            return {
                //prevObjectiveId: props.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                rows: null,
                statePeriod: nextProps.params.statePeriod,
                isStatePeriod: nextProps.params.isStatePeriod
            }
        }
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }

        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.params.isRefresh !== this.state.isRefresh) ||
            (prevProps.params.statePeriod !== this.state.statePeriod)) {                
            this.getDataFromAPI();
        }

    }
    componentWillUnmount() {

    }

    getFetchs = (user, api_auth, objectiveId, fecha_inicio, fecha_termino, token) =>{
        return new Promise((resolve, reject) => {
            var listDays = []
            var fetches = []
            while (fecha_inicio <= fecha_termino) {
                var startDate=fecha_inicio.format("Y-MM-DD HH:mm")
                var finalDate=fecha_inicio.add(1, "days").format("Y-MM-DD HH:mm")
                //console.log(startDate, finalDate)
                var fetchDataDay=fetch(api_host+`/reporte/online/eventos/Reporte3Events/?user=${user}&key=${api_auth}&objetive=${objectiveId}&datebegin=${startDate}&finaldate=${finalDate}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}`)
                .then( response => response.json())
                fetches.push(                    
                    fetchDataDay.then( dataDay =>  {
                        var arrayDatesBegin=[]
                        dataDay.map(eleNode=>{
                            eleNode.data_nodo.map(eleData=>{
                                eleData.map(ele=>{
                                    arrayDatesBegin.push(moment(ele.desde))
                                })
                            })
                        })
                        arrayDatesBegin.sort(function (a, b) {
                            return (a - b);
                        });
                        var contDate=arrayDatesBegin[0].format("Y-MM-DD")
                        //console.log(contDate)
                        //console.log(dataDay)
                        listDays[contDate] = dataDay;
                        
                    })                    
                )
                
            }
            Promise.all(fetches).then(() => {
                resolve(listDays);
            })      
        });
    }

    getDataFromAPI = (objectiveId) => {
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod, step, isStepDowntime } = this.props.params
        const { history } = this.props;
        const {time} = this.state

        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            fetch(api_host + `/reporte/online/indicadores/getResumenDisponibilidadGlobalObjetivoCustom/?key=${api_auth}&horarioId=0&objetivoId=${objetivo_id}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&token=${token}&nodoId=0`)
            .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);             
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                'step',
                                period,
                                fecha_inicio,
                                fecha_termino)
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                });
        } else {
            let finalTime = (moment().format('YYYY-MM-DD HH:mm'))
            let beginTime = (moment().subtract(1, "hours").format('YYYY-MM-DD HH:mm'))
            if (this.state.time === 'd') {
                beginTime = (moment().subtract(1, "days").format('YYYY-MM-DD HH:mm'))
            }
            if (this.state.time === '3h') {
                beginTime = (moment().subtract(3, "hours").format('YYYY-MM-DD HH:mm'))
            }
            fetch(api_host + `/reporte/online/indicadores/getResumenDisponibilidadGlobalObjetivo/?key=${api_auth}&objetivoId=${objetivo_id}&horarioId=0&t=${time}&token=${token}&nodoId=0`)
            .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);             
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                'step',
                                period,
                                beginTime,
                                finalTime)
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                });

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (data,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        step,
        period,
        fecha_inicio,
        fecha_termino) => {
            const newState = { ...this.state }; 
            var arrayDataUptime = []
            var arrayDataDowntime = []
            var arrayDataPartial = []
            var arrayDataNoMon = []
            var arrayDataEvent = []
            var arrayData = []
            var arraySteps = []
            var arrayDataMarcadoAtentus = []

            Object.values(data['Objetivo']['Paso']).map(key =>{
                var dictUptime = {};
                var dictDowntime = {}
                var dictPartial = {};
                var dictNoMon = {}
                var dictEvent = {};
                var dictMarcadoAtentus = {};
                arraySteps.push(key['paso_nombre'])
                Object.values(key['estado']).map(keyEstado =>{
                    
                    dictUptime['Paso'] = key['paso_nombre']
                    dictDowntime['Paso'] = key['paso_nombre']
                    dictPartial['Paso'] = key['paso_nombre']
                    dictNoMon['Paso'] = key['paso_nombre']
                    dictEvent['Paso'] = key['paso_nombre']
                   
                    var nombre = Object.entries(keyEstado)[0][0]

                    Object.values(keyEstado).map (keyFecha =>{
                        var contUptime = 0
                        var contDowntime = 0
                        var contPartial = 0
                        var contNoMon = 0
                        var contEvent = 0
                        var contMarcadoAtentus = 0
                        Object.values(keyFecha).map(keyIndex =>{
                            
                            if (keyIndex['nombre'] == 'uptime'){
                                dictUptime[nombre] = keyIndex['porcentaje']
                                contUptime = contUptime + 1
                            }
                            if (keyIndex['nombre'] == 'downtime'){
                                dictDowntime[nombre] = keyIndex['porcentaje']
                                contDowntime = contDowntime + 1
                            }
                            if (keyIndex['nombre'] == 'downtime parcial'){
                                dictPartial[nombre] = keyIndex['porcentaje']
                                contPartial = contPartial + 1
                            }
                            if (keyIndex['nombre'] == 'no monitoreo'){
                                dictNoMon[nombre] = keyIndex['porcentaje']
                                contNoMon = contNoMon + 1
                            }
                            if (keyIndex['nombre'] == 'evento cliente'){
                                dictEvent[nombre] = keyIndex['porcentaje']
                                contEvent = contEvent + 1
                            }
                            if (keyIndex['nombre'] == 'marcado atentus'){
                                dictMarcadoAtentus[nombre] = keyIndex['porcentaje']
                                contMarcadoAtentus = contMarcadoAtentus + 1
                            }

                            if (contUptime == 0){
                                dictUptime[nombre] = 0
                            }
                            if (contDowntime == 0){
                                dictDowntime[nombre] = 0
                            }
                            if (contPartial == 0){
                                dictPartial[nombre] = 0
                            }
                            if (contNoMon == 0){
                                dictNoMon[nombre] = 0
                            }
                            if (contEvent == 0){
                                dictEvent[nombre] = 0
                            }
                            if (contMarcadoAtentus == 0){
                                dictMarcadoAtentus[nombre] = 0
                            }
                        })
                        
                    })
                    
                })
                arrayDataUptime.push(dictUptime)
                arrayDataDowntime.push(dictDowntime)
                arrayDataPartial.push(dictPartial)
                arrayDataNoMon.push(dictNoMon)
                arrayDataEvent.push(dictEvent)
                arrayDataMarcadoAtentus.push(dictMarcadoAtentus)
            })
            newState['arrayDataUptime'] = arrayDataUptime
            newState['arrayDataDowntime'] = arrayDataDowntime
            newState['arrayDataPartial'] = arrayDataPartial
            newState['arrayDataNoMon'] = arrayDataNoMon
            newState['arrayDataEvent'] = arrayDataUptime
            newState['arrayDataMarcadoAtentus'] = arrayDataMarcadoAtentus
            newState['arraySteps'] = arraySteps
            newState['isLoading'] = false
            newState['dataError'] = false
            newState['beginDate'] = fecha_inicio
            newState['endDate'] = fecha_termino

            this.newArrayData(newState)
            
       
    }

    handleChange = event => {
        this.setState({value: event.target.value});
    };
    handleChangeDecimal = event => {
        const newState = { ...this.state }; 
        newState['valueDecimal'] = event.target.value
        this.newArrayData(newState)
    };

    newArrayData (newState) {
        var arrayData = []
  
        if (newState['checkedUptime'] == false && newState['checkedDowntime'] == false
            && newState['checkedPartial'] == false && newState['checkedNoMon'] == false 
            && newState['checkedEvent'] == false && newState['checkedMarcadoAtentus'] == false){
                newState['checked'] = false
        } else {
            if (newState['checked'] == false){
                newState['checked'] = true
            }
            newState['arraySteps'].forEach(function(value, key){
                var arrayUptimeDecimal = []
                var arrayDowntimeDecimal = []
                var arrayPartialDecimal = []
                var arrayNoMonDecimal = []
                var arrayEventDecimal = []
                var arrayMarcadoAtentusDecimal = []
                
                var arrayKey = []
                var dictData = {};
                dictData['Paso'] = value
                for (var data of newState['arrayDataUptime']){
                    Object.keys(data).map(key =>{
                        if (key != 'Paso') {
                            arrayKey.push(key)
                        }
                    })
                    break
                }
                
                var sucessUptime = false
                var sucessDowntime = false
                var sucessPartial = false
                var sucessNoMon = false
                var sucessEvent = false
                var sucessMarcadoAtentus = false
                if (newState['checkedUptime'] == true){
                    for (var data of newState['arrayDataUptime']){
                        if (data['Paso'] == value){
                            Object.keys(data).map(key =>{
                                if (key != 'Paso') {
                                    arrayUptimeDecimal.push(data[key])
                                }
                            })
                            sucessUptime = true
                        } else if(sucessUptime == true) {
                            break
                        }
                    }
                }
                if (newState['checkedDowntime'] == true){
                    for (var data of newState['arrayDataDowntime']){
                        if (data['Paso'] == value){
                            Object.keys(data).map(key =>{
                                if (key != 'Paso') {
                                    arrayDowntimeDecimal.push(data[key])
                                }
                            })
                            sucessDowntime = true
                        } else if(sucessDowntime == true) {
                            break
                        }
                    }
                }
                if (newState['checkedPartial'] == true){
                    for (var data of newState['arrayDataPartial']){
                        if (data['Paso'] == value){
                            Object.keys(data).map(key =>{
                                if (key != 'Paso') {
                                    arrayPartialDecimal.push(data[key])
                                }
                            })
                            sucessPartial = true
                        } else if(sucessPartial == true) {
                            break
                        }
                    }
                }
                if (newState['checkedNoMon'] == true){
                    for (var data of newState['arrayDataNoMon']){
                        if (data['Paso'] == value){
                            Object.keys(data).map(key =>{
                                if (key != 'Paso') {
                                    arrayNoMonDecimal.push(data[key])
                                }
                            })
                            sucessNoMon = true
                        } else if(sucessNoMon == true) {
                            break
                        }
                    }
                }
                if (newState['checkedEvent'] == true){
                    for (var data of newState['arrayDataEvent']){
                        if (data['Paso'] == value){
                            Object.keys(data).map(key =>{
                                if (key != 'Paso') {
                                    arrayEventDecimal.push(data[key])
                                }
                            })
                            sucessEvent = true
                        } else if(sucessEvent == true) {
                            break
                        }
                    }
                }
                if (newState['checkedMarcadoAtentus'] == true){
                    for (var data of newState['arrayDataMarcadoAtentus']){
                        if (data['Paso'] == value){
                            Object.keys(data).map(key =>{
                                if (key != 'Paso') {
                                    arrayMarcadoAtentusDecimal.push(data[key])
                                }
                            })
                            sucessMarcadoAtentus = true
                        } else if(sucessMarcadoAtentus == true) {
                            break
                        }
                    }
                }
                
                for (var i = 0; i < arrayKey.length; i++) {
                    var decimal = 0
                    var a = 0
                    var b = 0
                    var c = 0
                    var d = 0
                    var e = 0
                    var f = 0

                    if (newState['checkedUptime'] == true){
                        a = arrayUptimeDecimal[i]
                    } 
                    if (newState['checkedDowntime'] == true){
                        b = arrayDowntimeDecimal[i]
                    }
                    if (newState['checkedPartial'] == true){
                        c = arrayPartialDecimal[i]
                    } 
                    if (newState['checkedNoMon'] == true){
                        d = arrayNoMonDecimal[i]
                    }
                    if (newState['checkedEvent'] == true){
                        e = arrayEventDecimal[i]
                    } 
                    if (newState['checkedMarcadoAtentus'] == true){
                        f = arrayMarcadoAtentusDecimal[i]
                    }
                    decimal = a+b+c+d+e
                    var decimalFinal = decimal.toFixed(2)
                    if (newState['valueDecimal'] == ','){
                        decimalFinal = decimalFinal.replace('.', ',')
                    }
                    dictData[arrayKey[i]] = decimalFinal+'%'
                }
                arrayData.push(dictData)
            })
            newState['data'] = arrayData
        }
        this.setState(newState);
    }

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState[field] = value;  
        this.newArrayData(newState)
    };

    render() {
        const t = this.translation
        const { dataError, isLoading, data, noMonCum, downCum, dataTab, value, valueDecimal, checkedDowntime, 
            checkedUptime, checkedPartial, checkedNoMon, checkedEvent, checkedMarcadoAtentus, checked, nameObjective, beginDate, endDate } = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' }; 
        if (!dataError) {
            return (<FormattedChart handleChange={this.handleChange} handleChangeDecimal={this.handleChangeDecimal} handleAvailabilityChange={this.handleFieldChange} 
                value={value} valueDecimal={valueDecimal} data={data} dataTab={dataTab} noMonCum={noMonCum} downCum={downCum} 
                isLoading={isLoading} style={style} styleHidden={styleHidden} checkedDowntime={checkedDowntime}
                checkedUptime={checkedUptime} checkedPartial={checkedPartial} checkedNoMon={checkedNoMon} checkedEvent={checkedEvent}
                checked={checked} nameObjective={nameObjective} beginDate={beginDate} endDate={endDate} checkedMarcadoAtentus={checkedMarcadoAtentus} t={t} />) 
        }
        else if (dataError) {
            return (<p>{t('monitoring.tools-section.download-data.modal.availability-by-day.no-data')}</p>)
        }
        else return (<p> Error!</p >)

    }
}

function FormattedChart(props) {
    const t = props.t
    return (
        <div>
            { props.data == null  ? 
                <PortletContent>
                    <PerfectScrollbar>

                        <Typography
                        variant="h5"
                        >
                        <CircularProgress
                        variant="indeterminate"

                        size={24}
                        thickness={4}
                        
                        />
                        <br/>
                        {t('text.loading')}
                    </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            :
                <div style={{ maxWidth: "100%" }}>
                    
                            
                    <Table>
                        <TableRow>
                            <TableCell style={{borderBottom: "none"}}>
                                <Typography
                                    variant="h6"
                                    >
                                    {t('monitoring.tools-section.download-data.modal.availability-by-day.form.character-set.label')}
                                            </Typography>
                            </TableCell>
                            <TableCell style={{borderBottom: "none"}}>
                                <FormControl /*className={classes.formControl}*/> 
                                    
                                    <NativeSelect
                                        //className={classes.textFieldSelect}
                                        /*onChange={event =>
                                            this.handleFieldChange('destinatario', event.target.value)
                                        }*/
                                        defaultValue={1}
                                        inputProps={{
                                            name: 'name',
                                            id: 'uncontrolled-native',
                                        }}
                                    >
                                        {/*<option value={0}>Windows (LATIN1)</option>*/}
                                        <option value={1}>{t('monitoring.tools-section.download-data.modal.availability-by-day.form.character-set.option.utf8')}</option>
                                        
                                    </NativeSelect>
                                </FormControl> 
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <Typography
                                    variant="h6"
                                    >{t('monitoring.tools-section.download-data.modal.availability-by-day.form.separator.label')}</Typography>
                            </TableCell>
                            <TableCell>
                                <FormControl component="fieldset">
                                    
                                    <RadioGroup defaultValue={","} aria-label="gender" name="customized-radios"  onClick={props.handleChange}>
                                        <FormControlLabel value="," control={<Radio />} label={t('monitoring.tools-section.download-data.modal.availability-by-day.form.separator.option.coma')} />
                                        <FormControlLabel value=";" control={<Radio />} label={t('monitoring.tools-section.download-data.modal.availability-by-day.form.separator.option.semicolon')} />
                                        
                                    </RadioGroup>
                                </FormControl>
                            </TableCell>
                        </TableRow> 
                        <TableRow>
                            <TableCell>
                                <Typography
                                    variant="h6"
                                    >{t('monitoring.tools-section.download-data.modal.availability-by-day.form.character-decimal.label')}</Typography>
                            </TableCell>
                            <TableCell>
                                <FormControl component="fieldset">
                                    
                                    <RadioGroup defaultValue={"."} aria-label="gender" name="customized-radios"  onClick={props.handleChangeDecimal}>
                                        <FormControlLabel value="." control={<Radio />} label={t('monitoring.tools-section.download-data.modal.availability-by-day.form.character-decimal.option.point')} />    
                                        <FormControlLabel value="," control={<Radio />} label={t('monitoring.tools-section.download-data.modal.availability-by-day.form.character-decimal.option.coma')} /> 
                                    </RadioGroup>
                                </FormControl>
                            </TableCell>
                        </TableRow> 
                        <TableRow>
                            <TableCell>
                                <Typography
                                    variant="h6"
                                    >{t('monitoring.tools-section.download-data.modal.availability-by-day.form.availability-shown')}</Typography> 
                            </TableCell>
                            <TableCell>
                                <FormControl component="fieldset" /*className={classes.formControl}*/>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={<Checkbox checked={props.checkedUptime} onChange={event =>
                                                props.handleAvailabilityChange('checkedUptime', event.target.checked)
                                            } name="Uptime" />}
                                            label={t('monitoring.tools-section.download-data.modal.availability-by-day.form.availability-shown.option.uptime')}
                                        />
                                        {/* <FormControlLabel
                                            control={<Checkbox checked={props.checkedPartial} onChange={event =>
                                                props.handleAvailabilityChange('checkedPartial', event.target.checked)
                                            } name="Partial" />}
                                            label="Downtime Parcial"
                                        /> */}
                                        <FormControlLabel
                                            control={<Checkbox checked={props.checkedDowntime} onChange={event =>
                                                props.handleAvailabilityChange('checkedDowntime', event.target.checked)
                                            } name="Downtime" />}
                                            label={t('monitoring.tools-section.download-data.modal.availability-by-day.form.availability-shown.option.downtime')}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={props.checkedNoMon} onChange={event =>
                                                props.handleAvailabilityChange('checkedNoMon', event.target.checked)
                                            } name="NoMonitoring" />}
                                            label={t('monitoring.tools-section.download-data.modal.availability-by-day.form.availability-shown.option.no-monitoring')}
                                        />
                                        {/* <FormControlLabel
                                            control={<Checkbox checked={props.checkedEvent} onChange={event =>
                                                props.handleAvailabilityChange('checkedEvent', event.target.checked)
                                            } name="EventClient" />}
                                            label="Evento Cliente"
                                        /> */}
                                    </FormGroup>
                                </FormControl>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{borderBottom: "none"}}>
                                <CSVLink data={props.data} separator={props.value} onClick={event => {
                                        if (props.checked == false) {
                                            alert(t('monitoring.tools-section.download-data.modal.availability-by-day.form.alert.at-least-one-availability'));
                                        }
                                        return props.checked; 
                                        
                                    }}
                                    filename={props.nameObjective+"("+props.beginDate+" a "+props.endDate+")disponibilidad.csv"}>
                                    <Button variant="contained" color="primary" size="small">{t('monitoring.tools-section.download-data.modal.availability-by-day.form.button.download-csv')}</Button>
                                </CSVLink>
                                
                            </TableCell>
                            
                        </TableRow>            
                    </Table>        
                            
                
                </div>}
            </div>
        )

}


export default compose(
    withRouter,
    withTranslation()
)(AvailabilityData);